import { lazy } from "react";

const SignIn = lazy(() => import("./Pages/Authentication/SignIn/SignIn"));
const VerifyEmail = lazy(() => import("./Pages/Authentication/VerifyEmail"));
const Unsubscribe = lazy(() => import("./Pages/Authentication/Unsubscribe"));
//const SignUp = lazy(() => import("./Pages/Authentication/SignUp/SignUp"));
const ResetPassword = lazy(() => import("./Pages/Authentication/ResetPassword/ResetPassword"));
const SetPassword = lazy(() => import("./Pages/Authentication/ResetPassword/SetPassword"));

const route = [
  //{ path: ["/auth/signup", "/register", "/sign-up", "/create-an-account"], exact: true, name: "Signup", component: SignUp },
  {
    path: "/login",
    exact: true,
    name: "Signin",
    component: <SignIn />,
    title: "Dashboard",
  },
  {
    path: "/auth/reset-password",
    exact: true,
    name: "Reset Password",
    component: <ResetPassword />,
  },
  {
    path: "/auth/set-password",
    exact: true,
    name: "Set Password",
    component: <SetPassword />,
  },
  {
    path: "/auth/verify-email",
    exact: true,
    name: "Verify Email",
    component: <VerifyEmail />,
  },
  {
    path: "/unsubscribe/:email?",
    exact: true,
    name: "Unsubscribe",
    component: <Unsubscribe />,
  },
];

export default route;
